import React from 'react';
import { Button } from './Button';
import { Reveal } from './Reveal';
export function EmployerCta() {
  return <section className="bg-navy py-20 lg:py-28" data-id="element-121" data-mp="3n5w1egm0zx74">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-122" data-mp="3n6nxrtng5yyg">
        <Reveal className="grid gap-10 border border-gold/35 px-8 py-12 sm:px-12 lg:grid-cols-12 lg:items-end lg:gap-12 lg:px-16 lg:py-20" data-id="element-123" data-mp="3s34p0wpy0tfr">
          <div className="lg:col-span-7" data-id="element-124" data-mp="3w36gye5vm8hu">
            <p className="text-sm font-medium text-gold" data-id="element-125" data-mp="4y6nksxfmzmw">For Employers</p>
            <h2 className="mt-5 font-serif text-4xl font-medium leading-[1.05] text-white sm:text-5xl lg:text-6xl" data-id="element-126" data-mp="9y1gf20rpzal">
              Looking for the right talent for a key role?
            </h2>
          </div>
          <div className="lg:col-span-5" data-id="element-127" data-mp="jomacc5hyfn6">
            <span className="block h-px w-12 bg-gold" aria-hidden="true" data-id="element-128" data-mp="jnl029wb1x6i" />
            <p className="mt-6 text-lg leading-relaxed text-white/75" data-id="element-129" data-mp="nqr2f6gar47p">
              Share your hiring requirements and we’ll discuss how executive search, talent
              sourcing, or recruitment support may help you reach the right candidates.
            </p>
            <Button to="/employers#enquiry" className="mt-8 focus-visible:ring-offset-navy" data-id="element-130" data-mp="xtd534v1twb0">
              Hire Talent With Us
            </Button>
          </div>
        </Reveal>
      </div>
    </section>;
}